<template>
  <component :is="linkComponent" v-bind="linkProps" :target="target" :tabindex="disabled ? -1 : 0">
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: "Link",
  props: {
    to: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    newTab: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isInternal() {
      const internal = /^\/(?!\/)/.test(this.to);
      const file = /\.[0-9a-z]+$/i.test(this.to);
      return internal && !file;
    },
    linkComponent() {
      if (this.newTab) {
        return "a";
      }

      return this.isInternal ? "router-link" : "a";
    },
    linkProps() {
      if (this.newTab) {
        return { "href": this.to };
      }

      return Object.assign(
        {},
        {
          [this.isInternal ? "to" : "href"]: this.to,
        }
      );
    },
    target() {
      if (this.newTab) {
        return "_blank";
      }

      return this.newTab && !this.isInternal ? "_blank" : "_self";
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  outline: none;
  &:visited {
    color: initial;
  }
}
</style>
